module.exports = __webpack_public_path__ + "img/icon.50cfc59b.png";